// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ap5m","rootMobile":"styles_rootMobile__32_Ib"};